module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "align-with-title": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-spacer'), _c('v-tabs-slider', {
    attrs: {
      "color": "primary"
    }
  }), _c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiple || !_vm.files.length && !_vm.multiple),
      expression: "multiple || !files.length && !multiple"
    }],
    key: "upload"
  }, [_c('span', [_vm._v("Adjuntar")])]), (_vm.files.length) ? _c('v-tab', {
    key: "archivos"
  }, [_c('span', [_vm._v(_vm._s(_vm.files.length) + " Archivo(s)")])]) : _vm._e()], 1), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiple || !_vm.files.length && !_vm.multiple),
      expression: "multiple || !files.length && !multiple"
    }],
    key: "adjuntar",
    attrs: {
      "disabled": _vm.isMovil
    }
  }, [_c('v-card', {
    staticClass: "elevation-0 d-flex jc-center ai-center fd-column",
    class: {
      'opacity-5': _vm.$upload.dropzone(_vm.name).active
    },
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 118px)' : '500',
      "id": "dropzone"
    },
    on: {
      "click": _vm.select
    }
  }, [_c('div', [(_vm.accept && _vm.accept[0] === 'image/*') ? _c('div', {
    staticClass: "d-flex transform-icons"
  }, [(!_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    staticClass: "center",
    attrs: {
      "size": _vm.modeInsert ? 70 : 100,
      "color": "primary"
    }
  }, [_vm._v("image_search")]) : _vm._e()], 1) : _c('div', {
    staticClass: "d-flex transform-icons"
  }, [(!_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    staticClass: "left",
    attrs: {
      "size": _vm.modeInsert ? 40 : 60,
      "color": "primary"
    }
  }, [_vm._v("picture_as_pdf")]) : _vm._e(), (!_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    staticClass: "center",
    attrs: {
      "size": _vm.modeInsert ? 40 : 60,
      "color": "primary"
    }
  }, [_vm._v("insert_photo")]) : _vm._e(), (!_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    staticClass: "right",
    attrs: {
      "size": _vm.modeInsert ? 40 : 60,
      "color": "primary"
    }
  }, [_vm._v("text_snippet")]) : _vm._e()], 1), (_vm.$upload.dropzone(_vm.name).active) ? _c('v-icon', {
    attrs: {
      "size": "80px",
      "color": "primary"
    }
  }, [_vm._v("preview")]) : _vm._e()], 1), _c('v-card-text', {
    staticClass: "text-center"
  }, [(!_vm.isMovil) ? [(!_vm.$upload.dropzone(_vm.name).active) ? _c('h2', {
    staticClass: "primary--text"
  }, [(_vm.multiple) ? [_vm._v("Arrastra y suelta tus archivos aquí")] : [_vm._v("Arrastra y suelta el archivo aquí")]], 2) : _c('h2', {
    staticClass: "primary--text"
  }, [(_vm.multiple) ? [_vm._v("Suelta tus archivos para visualizarlos")] : [_vm._v("Suelta el archivo para visualizarlo")]], 2)] : [_c('h2', {
    staticClass: "primary--text"
  }, [_vm._v("Busca tus archivos en tu galeria")])], _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('small', [_vm._v("*Subir archivos con un peso no mayor a 10MB*")]), _c('small', {
    staticClass: "primary--text font-weight-700"
  }, [_vm._v(_vm._s(_vm.extensionsAllow.toString()))])])], 2)], 1)], 1), _c('v-tab-item', {
    key: "archivos",
    attrs: {
      "disabled": _vm.isMovil
    }
  }, [(_vm.$upload.errors(_vm.name).length > 0) ? _c('v-alert', {
    staticClass: "mb-0",
    attrs: {
      "dense": "",
      "text": "text",
      "type": "error"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, _vm._l((_vm.$upload.errors(_vm.name)), function(e, i) {
    return _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" • " + _vm._s(e.msg) + "  "), _c('span', {
      staticClass: "font-weight-700"
    }, [_vm._v("(" + _vm._s(e.file.name) + ")")])])
  }), 0)]) : _vm._e(), (_vm.files.length) ? _c('preview-files', {
    ref: "previsualizador",
    attrs: {
      "archivos": _vm.files,
      "mode-insert": _vm.modeInsert,
      "is-set-profile": _vm.isSetProfile
    },
    on: {
      "remove": _vm.removeFile
    }
  }) : _vm._e()], 1)], 1), (!_vm.modeInsert) ? _c('div', {
    staticClass: "pa-4 d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [(_vm.tab) ? _c('v-btn', {
    class: {
      'mb-3': _vm.isMovil
    },
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.volverASeleccionar()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("arrow_back")]), (!_vm.multiple) ? _c('span', [_vm._v("Volver a seleccionar")]) : _c('span', [_vm._v("Seguir seleccionando")])], 1) : _vm._e(), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), (_vm.files.length && _vm.tab) ? _c('v-btn', {
    class: {
      'mb-3': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.sendFilesToSave()
      }
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), (_vm.isMovil || !_vm.tab) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("cancelar")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26f6a596","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_adjuntar_archivos.vue
// module id = 485
// module chunks = 1